export default function PreviewIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="95" height="88" viewBox="0 0 95 88" fill="none">
      <mask
        id="mask0_429_5991"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="95"
        height="88"
      >
        <rect width="94.1776" height="87.1143" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_429_5991)">
        <g filter="url(#filter0_d_429_5991)">
          <path
            d="M10.5936 2.94434H83.5809C88.4571 2.94434 92.41 6.89723 92.41 11.7734V91.2354H1.76453V11.7734C1.76453 6.89723 5.71742 2.94434 10.5936 2.94434Z"
            fill="#F4F4F4"
            fillOpacity="0.5"
            stroke="#DEE1EB"
            strokeWidth="1.17722"
          />
          <path
            d="M87.0155 29.5332L7.77177 29.5332L7.77177 27.4478C7.77177 23.9927 10.5727 21.1918 14.0279 21.1918L80.7594 21.1918C84.2146 21.1918 87.0155 23.9927 87.0155 27.4478L87.0155 29.5332Z"
            fill="#FFB4C9"
          />
          <g filter="url(#filter1_d_429_5991)">
            <path
              d="M7.77325 29.5315C7.77325 26.0763 10.5742 23.2754 14.0293 23.2754H80.7609C84.216 23.2754 87.017 26.0763 87.017 29.5315V48.2997C87.017 51.7549 84.216 54.5558 80.7609 54.5558H14.0293C10.5742 54.5558 7.77325 51.7549 7.77325 48.2997V29.5315Z"
              fill="white"
            />
            <path
              d="M14.0291 23.5879H80.7606C84.0429 23.5879 86.7038 26.249 86.7039 29.5312V48.2998C86.7039 51.5822 84.0429 54.2432 80.7606 54.2432H14.0291C10.7469 54.243 8.08579 51.5821 8.08575 48.2998V29.5312C8.08588 26.249 10.7469 23.588 14.0291 23.5879Z"
              stroke="#AFB3BF"
              strokeWidth="0.625609"
            />
          </g>
          <rect x="13.8555" y="31.4199" width="49.2346" height="1.59853" rx="0.799263" fill="#DEE1EB" />
          <rect x="13.8555" y="36.8555" width="63.3016" height="1.59853" rx="0.799263" fill="#DEE1EB" />
          <rect x="10.5986" y="10.125" width="47.0888" height="4.70888" rx="0.959116" fill="#D5D5D5" />
          <path
            d="M87.0155 69.1562L7.77177 69.1562L7.77177 67.0709C7.77177 63.6157 10.5727 60.8148 14.0279 60.8148L80.7594 60.8148C84.2146 60.8148 87.0155 63.6158 87.0155 67.0709L87.0155 69.1562Z"
            fill="#FADA9E"
          />
          <g filter="url(#filter2_d_429_5991)">
            <path
              d="M7.77332 69.1545C7.77332 65.6994 10.5743 62.8984 14.0294 62.8984H80.761C84.2161 62.8984 87.0171 65.6994 87.0171 69.1545V87.9228C87.0171 91.3779 84.2161 94.1789 80.761 94.1789H14.0294C10.5743 94.1789 7.77332 91.3779 7.77332 87.9228V69.1545Z"
              fill="white"
            />
            <path
              d="M14.0292 63.2109H80.7606C84.0429 63.2109 86.7039 65.872 86.704 69.1543V87.9229C86.7039 91.2052 84.043 93.8662 80.7606 93.8662H14.0292C10.7469 93.8661 8.08586 91.2051 8.08582 87.9229V69.1543C8.08594 65.8721 10.747 63.2111 14.0292 63.2109Z"
              stroke="#AFB3BF"
              strokeWidth="0.625609"
            />
          </g>
          <rect x="13.8555" y="71.043" width="49.2346" height="1.59853" rx="0.799263" fill="#DEE1EB" />
          <rect x="13.8555" y="76.4785" width="63.3016" height="1.59853" rx="0.799263" fill="#DEE1EB" />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_429_5991"
          x="-8.2421"
          y="-7.06229"
          width="110.659"
          height="110.659"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.70888" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_429_5991" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_429_5991" result="shape" />
        </filter>
        <filter
          id="filter1_d_429_5991"
          x="3.38489"
          y="18.887"
          width="88.0204"
          height="40.0572"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.19418" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_429_5991" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_429_5991" result="shape" />
        </filter>
        <filter
          id="filter2_d_429_5991"
          x="3.38495"
          y="58.5101"
          width="88.0204"
          height="40.0572"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.19418" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_429_5991" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_429_5991" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}
